import { useCallback, useState } from 'react';
import { CHAT_PANEL_RESIZE_STEP } from '../../constants/chat';
import { useChatPanelWidth } from './useChatPanelWidth';

export const useChatPanelResize = () => {
  const { width, maxWidth, setWidth, maximize } = useChatPanelWidth();
  const [isResizing, setIsResizing] = useState(false);

  const onPointerDown = useCallback((event: React.PointerEvent) => {
    event.preventDefault();
    setIsResizing(true);
    event.currentTarget.setPointerCapture?.(event.pointerId);
  }, []);

  const onPointerMove = useCallback(
    (event: React.PointerEvent) => {
      if (!isResizing) {
        return;
      }
      setWidth(window.innerWidth - event.clientX);
    },
    [isResizing, setWidth],
  );

  const onPointerUp = useCallback((event: React.PointerEvent) => {
    setIsResizing(false);
    event.currentTarget.releasePointerCapture?.(event.pointerId);
  }, []);

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setWidth(width + CHAT_PANEL_RESIZE_STEP);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setWidth(width - CHAT_PANEL_RESIZE_STEP);
      }
    },
    [setWidth, width],
  );

  return {
    width,
    maxWidth,
    isResizing,
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onKeyDown,
    onDoubleClick: maximize,
  };
};
